import { orderApprovalDetailsTotalStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsTotal";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

orderApprovalDetailsTotalStyles.cartTotal = {
    container: {
        gap: 10,
        css: css`
            background-color: ${getColor("common.ui2")};
            padding: 20px;
        `,
    },
};
